import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Events Gallery', path: '/events' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50" data-testid="navbar">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <div className="flex-shrink-0">
            <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_usha-control/artifacts/ugawy9rv_Screenshot%202026-02-17%20122401.png" 
                alt="Usha Automation Logo" 
                className="h-12 w-auto"
                data-testid="logo-image"
              />
              <div className="flex flex-col">
                <span className="text-lg font-bold text-slate-900 whitespace-nowrap" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  Usha Automation
                </span>
                <span className="text-xs text-slate-500 italic whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Ethical steps towards technology
                </span>
              </div>
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm font-medium transition-all duration-300 relative group px-1 py-2 whitespace-nowrap ${
                  isActive(item.path) 
                    ? 'text-[#FF7F2A]' 
                    : 'text-slate-700 hover:text-[#FF7F2A]'
                }`}
                data-testid={`nav-link-${item.name.toLowerCase().replace(' ', '-')}`}
              >
                {item.name}
                <span className={`absolute bottom-0 left-0 h-0.5 bg-[#FF7F2A] transition-all duration-300 ${
                  isActive(item.path) ? 'w-full' : 'w-0 group-hover:w-full'
                }`}></span>
              </Link>
            ))}
            <Link
              to="/contact"
              className="bg-[#FF7F2A] text-white hover:bg-[#e66e1f] rounded-sm px-5 py-2.5 text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-300 whitespace-nowrap ml-2"
              data-testid="nav-cta-button"
            >
              Get in Touch
            </Link>
          </div>

          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-700 hover:text-[#1E56A0] transition-colors"
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200" data-testid="mobile-menu">
          <div className="px-4 pt-2 pb-6 space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 rounded-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-[#FF7F2A] text-white'
                    : 'text-slate-700 hover:bg-slate-50 hover:text-[#FF7F2A]'
                }`}
                data-testid={`mobile-nav-link-${item.name.toLowerCase().replace(' ', '-')}`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="block text-center bg-[#FF7F2A] text-white hover:bg-[#e66e1f] rounded-sm px-6 py-3 font-semibold shadow-md hover:shadow-lg transition-all duration-300"
              data-testid="mobile-cta-button"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
